// M6 · Crisis card (QM6_Crisis). Shown when the chat emits a crisis event (the day screens route here) or from the
// test tools. Shared copy (CRISIS, not in character style) with real tel:/sms: links for 988 and the 988 chat site;
// "I'm safe. Keep talking" goes back to Chat.
import { C } from '@shared/content/characters';
import { CRISIS, LINES, fill } from '@shared/content/lines';
import { useApp, clearChatFlags } from '../../store';
import { replace } from '../../router';
import { Screen, XScene, TextButton } from '../../components';
import s from './me.module.css';
import { say } from '../../lib/say';

const CHAT_URL = 'https://988lifeline.org/chat';

export function CrisisScreen() {
  const st = useApp((x) => x.state);
  const pending = useApp((x) => x.chat.pending);
  const ch = st?.ch || 'margo';
  const c = C[ch];
  // What the user said that triggered this: the crisis turn is [user, buddy crisisLine, system 'crisis'].
  const all = (st?.messages || []).concat(pending);
  let ci = -1;
  for (let i = all.length - 1; i >= 0; i--) if (all[i].kind === 'crisis') { ci = i; break; }
  const trigger = ci >= 2 && all[ci].data?.source !== 'debug' ? all[ci - 2] : null;
  const said = trigger && trigger.role === 'user' && trigger.text ? trigger.text : null;
  const showSaid = !!said;

  return (
    <Screen theme={ch} id="M6">
      <XScene ch={ch} stage={st?.buddy.stage || 1} mode="night" video={false} alt="" />
      <div class={`${s.crisis} xm-scroll`}>
        {showSaid && <p class={s.said}><span class="xm-sr-only">You said: </span>{said}</p>}
        <div class={s.say} style={{ margin: 0, padding: '0 8px' }}>
          <p class={s.sayName}>{c.name}</p>
          <p class={s.sayLine}>{say(LINES[ch].crisisLine, { n: C[ch].name })}</p>
        </div>
        <section class={s.help} aria-label="Crisis support">
          <h1 class={s.helpT}>{CRISIS.title}</h1>
          <p class={s.helpB}>{CRISIS.body}</p>
          <a class={s.call} href="tel:988">{CRISIS.call}</a>
          <a class={s.text} href="sms:988">{CRISIS.text}</a>
          <a class={s.chatLink} href={CHAT_URL} target="_blank" rel="noopener noreferrer">{CRISIS.chat}</a>
        </section>
        <div class={s.safe}>
          <TextButton weight={600} onClick={() => { clearChatFlags(); replace('C'); }}>{CRISIS.safe}</TextButton>
          <p class={s.fineC}>{fill(CRISIS.fine, { n: c.name })}</p>
        </div>
      </div>
    </Screen>
  );
}
